import { defineMessages } from 'react-intl'

const messages = defineMessages({
  showAllRegions: {
    id: 'FilterModal.showAllRegions',
    description: 'Texto para el modal del filtro de todas las regiones',
    defaultMessage: 'Conjunto de regiones europeas (UE27_2020)'
  },
  showReferenceRegions: {
    id: 'FilterModal.showReferenceRegions',
    description: 'Texto para el modal del filtro de las regiones de referencia',
    defaultMessage: 'Regiones de referencia'
  },
  allRegionsModalBodyIntro: {
    id: 'FilterModal.allRegionsModalBodyIntro',
    description: 'Texto para la introducción del modal con UE28',
    defaultMessage:
			'Se compara la situación de <strong>{regionName}</strong> con la del conjunto de las <strong>{regionNumber} regiones</strong> de la UE27 (2020).'
  },
  referenceRegionsModalBodyIntro: {
    id: 'FilterModal.referenceRegionsModalBodyIntro',
    description: 'Texto para la introducción del modal con regiones de referencia',
    defaultMessage:
			'<strong>{regionName}</strong> se compara con un grupo de <strong>{regionNumber} regiones</strong> de características similares. Éstas han sido elegidas por ser las que presentan una mayor similitud con <strong>{regionName}</strong> en términos de condiciones estructurales de partida (sociodemográficas, e especialización económica y tecnológica, y de estructura empresarial).'
  },
  accept: {
    id: 'FilterModal.accept',
    description: 'Texto para el botón de aceptar del modal',
    defaultMessage: 'Aceptar'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/Filters/FilterModal/messages.js